import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import Modal from '../../components/Modal';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';

const SELECTOR_WRAPPER = '.p-school-onboarding-edit';
const SELECTOR_EDIT_CONTAINER = '.p-school-onboarding-edit-container';
const SELECTOR_MODAL = '#p-school-onboarding-edit-modal';
const SELECTOR_EXIT_WITHOUT_SAVING = '.js-account-edit-back-modal';
const SELECTOR_LEAVE_BUTTON = '.school-onboarding-edit-modal-leave'

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const KEY_OBJECT = "fieldName";
const VALUE_OBJECT = "value";

const IS_LOCAL = false;
class SchoolOnboardingEdit {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() { 
        return this._stepsData; 
    }

    set stepsData(_stepsData) { 
        this._stepsData = _stepsData; 
		if(_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
    }

	init() {
		this.navigationBackButtons = SelectorEngine.find('.js-account-edit-back', this._wrapper);
		this.exitWithoutSavingButton = SelectorEngine.findOne(SELECTOR_EXIT_WITHOUT_SAVING, this._wrapper);
		this.modalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.modalCloseButtons = SelectorEngine.find('.school-onboarding-edit-modal-close', this.modalElement);
		this.leavePageButton = SelectorEngine.findOne(SELECTOR_LEAVE_BUTTON, this.modalElement);
		this.editContainer = SelectorEngine.findOne(SELECTOR_EDIT_CONTAINER, this._wrapper);

		this.leaveModal = new Modal(this.modalElement, { backdrop: 'static' });

		for (const button of this.navigationBackButtons) {
			EventHandler.on(button, CLICK_EVENT, (event) => {
				this.goToUrl(event);
			});
		}
		for (const button of this.modalCloseButtons) {
			EventHandler.on(button, CLICK_EVENT, (event) => {
				this.leaveModal.hide();
			});
		}
		EventHandler.on(this.exitWithoutSavingButton, CLICK_EVENT, (event) => {
			this.leaveModal.show();
		});
		EventHandler.on(this.leavePageButton, CLICK_EVENT, (event) => {
			this.leaveModal.hide();
			this.goToUrl(event);
		});

		this.fetchSchoolOnboardingSteps();
	}

	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.editContainer, {
			questions: stepsData,
			isSeparator: true,
			totalSteps: 2,
			isHideProgress: true,
			titlePattern: "small",
			hasSeparator: false,
			formType: FormTypes.SectionForm,
			isRenderDependentQuestion: false,
			themeColor: "color-lta-accent-orange",
			submitButton: {
				title: 'Save changes',
				dataTarget: '/pages/find-court-phase-3/linked-child-accounts-details/',
				alwaysVisible: true
			}
		});
	
		for (const question of stepsData) {
			const answerObject = {
				fieldName : question.fieldName,
				value: question.value
			}
			this.formGenerator.updateAnswers(question, answerObject);
		}
		this.prepareRequestObject(this.formGenerator.answers);
		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
			this.saveSchoolOnboardingSteps(this.answerList)
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				}
			}
		}
	}
	async fetchSchoolOnboardingSteps() {
		try { 
			const url = "/api/teachermembership/editsteps";
			const response = await Request.get(url, {}, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			 	}
			});
			const { Steps, error } = response;
			if(Steps) {
				this.stepsData = Steps
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}

	async saveSchoolOnboardingSteps(requestObject) {
		try { 
			const url = "/api/account/updateschoolonboarding";
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			 	}
			});
			const { success, redirectUrl, error } = response;
			if(success) {
				const rootUrl = window.location.origin;
				window.location.href = `${rootUrl}${redirectUrl}`;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
	goToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalSchoolOnboardingEdit = new SchoolOnboardingEdit();
export default globalSchoolOnboardingEdit;
